// BrainSurface — the immersive Brain shell. MILESTONE 1 renders the RESTING Living
// Canvas only: nothing clicks, expands, or executes. Cipher's paged nav stays reachable
// via the explicit "← Cipher" return (spec §3 Tier 1). State (Execution/Reflection),
// focus, evidence, decide, and conversation are LATER milestones — their components stay
// in the tree (regions/, BrainContext, ConversationOverlay, …) but are NOT wired here.
//
// Not wrapped in DashboardLayout: the immersive field must not be subordinated to the
// dense sidebar. Flag OFF ⇒ this never mounts (existing app byte-identical).
import React from "react";
import { useNavigate } from "react-router-dom";
import LivingCanvas from "./LivingCanvas";
import { motion } from "./lib/motion";
import { useReducedMotion } from "./lib/useReducedMotion";

export default function BrainSurface() {
  const navigate = useNavigate();
  const reduce = useReducedMotion();

  const leave = () => {
    const m = motion("leave", { reducedMotion: reduce });
    // Presentation-only; the state change is a plain navigation (deep-link safe).
    if (!reduce && typeof document !== "undefined" && typeof document.startViewTransition === "function") {
      document.startViewTransition(() => navigate("/dashboard"));
    } else {
      navigate("/dashboard");
    }
    void m;
  };

  return (
    <div className="flex min-h-screen flex-col bg-slate-950 text-slate-100">
      {/* Minimal presence — the return + a FELT state indicator (not a tab row). */}
      <header className="flex items-center justify-between px-4 py-3 md:px-8">
        <button onClick={leave} data-testid="back-to-cipher" className="rounded-md border border-slate-800 px-3 py-1.5 text-xs text-slate-400 hover:bg-slate-900 hover:text-slate-200">
          ← Cipher
        </button>
        <div className="flex items-center gap-2 text-xs text-slate-600" aria-label="Brain state" data-testid="felt-state">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-slate-600" aria-hidden="true" />
          <span>resting</span>
        </div>
      </header>

      <main className="mx-auto w-full max-w-6xl flex-1 px-4 pb-10 md:px-8">
        <LivingCanvas />
      </main>
    </div>
  );
}
